import i18n from "../../utils/i18n";

export const schema = {
  "type": "object",
  "properties": {
    "name": {
      "type": "string",
      "minLength": 3,
      "description": i18n.t('secrets.save.name_helper'),
    },
    "secret": {
      "type": "string",
      "minLength": 3,
      "description": i18n.t('secrets.save.value_helper')
    },
    "description": {
      "type": "string",
      "description": i18n.t('secrets.save.description_helper')
    }
  },
  "required": [
    "name"
  ]
}

export const uischema = {
  type: "VerticalLayout",
  elements: [
    {
      type: "Control",
      scope: "#/properties/name",
      label: i18n.t('commons.name'),
    },
    {
      type: "Control",
      scope: "#/properties/description",
      label: i18n.t('commons.description'),
      options: {
        multi: true,
        rows: 2,
      }
    },
    {
      type: "Control",
      scope: "#/properties/secret",
      label: i18n.t('commons.secret'),
    },
  ],
}